import { colors, typography, shadows, radius, spacing } from './theme';

export const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: ${typography.fontFamily};
    background-color: ${colors.bg};
    color: ${colors.text};
    line-height: 1.6;
    min-height: 100vh;
  }

  body::before {
    content: '';
    position: fixed;
    inset: 0;
    z-index: -1;
    background:
      radial-gradient(ellipse 80% 48% at 18% -8%, rgba(20,184,166,0.16) 0%, transparent 50%),
      radial-gradient(ellipse 72% 42% at 92% 108%, rgba(15,118,110,0.12) 0%, transparent 50%),
      linear-gradient(180deg, #f0fdfa 0%, #ccfbf1 100%);
    pointer-events: none;
  }

  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    color: ${colors.text};
  }

  h1 { font-size: 36px; font-weight: 800; letter-spacing: -0.02em; }
  h2 { font-size: 30px; font-weight: 700; letter-spacing: -0.015em; }
  h3 { font-size: 24px; font-weight: 700; }
  h4 { font-size: 20px; font-weight: 700; }
  h5 { font-size: 18px; font-weight: 600; }
  h6 { font-size: 16px; font-weight: 600; }

  p { color: ${colors.textSecondary}; }
  a { color: ${colors.primary}; text-decoration: none; }

  /* Buttons */
  button {
    font-family: ${typography.fontFamily};
    cursor: pointer;
    border: none;
    transition: all 0.3s ease;
  }

  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  /* Inputs */
  input, textarea, select {
    font-family: ${typography.fontFamily};
    border-radius: ${radius.md};
    border: 1px solid ${colors.border};
    padding: ${spacing.md};
    font-size: 14px;
    transition: all 0.3s ease;
  }

  input:focus, textarea:focus, select:focus {
    outline: none;
    border-color: ${colors.primary};
    box-shadow: 0 0 0 3px ${colors.primaryGlow};
  }

  input::placeholder {
    color: ${colors.textTertiary};
  }

  /* Scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${colors.bg};
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.border};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${colors.borderDark};
  }

  /* Animations */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }

  @keyframes shimmer {
    0% { background-position: -1000px 0; }
    100% { background-position: 1000px 0; }
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  /* Utility Classes */
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .line-clamp-1 { display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden; }
  .line-clamp-2 { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  .line-clamp-3 { display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }

  .flex { display: flex; }
  .flex-col { display: flex; flex-direction: column; }
  .items-center { align-items: center; }
  .items-start { align-items: flex-start; }
  .items-end { align-items: flex-end; }
  .justify-center { justify-content: center; }
  .justify-between { justify-content: space-between; }
  .justify-end { justify-content: flex-end; }
  .gap-sm { gap: ${spacing.sm}; }
  .gap-md { gap: ${spacing.md}; }
  .gap-lg { gap: ${spacing.lg}; }
  .gap-xl { gap: ${spacing.xl}; }

  .cursor-pointer { cursor: pointer; }
  .opacity-50 { opacity: 0.5; }
  .opacity-75 { opacity: 0.75; }
`;

export default globalStyles;
